// @ts-nocheck
import * as React from "react";

const BackspaceLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M20.14 4A1.84 1.84 0 0122 5.82v12.36A1.84 1.84 0 0120.15 20h-9.77a3 3 0 01-2-.78l-6-5.48a1 1 0 01-.11-1.37l6-7.48.1-.11a3 3 0 012-.78zM20 6h-9.63a1 1 0 00-.62.22l-5.38 6.67 5.33 4.85a1 1 0 00.67.26H20V6zm-8.71 3.29a1.004 1.004 0 011.42 0l1.29 1.3 1.29-1.3a1.004 1.004 0 011.42 1.42L15.41 12l1.3 1.29a1.002 1.002 0 010 1.42l-.003.003a1 1 0 01-1.417-.003L14 13.41l-1.29 1.3a1 1 0 01-1.42 0l-.003-.003a1 1 0 01.003-1.417l1.3-1.29-1.3-1.29-.084-.095a1.004 1.004 0 01.084-1.325z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(BackspaceLine);
